export default __webpack_public_path__ + "static/media/userAvatar.10691648.png";